import { t } from "@lingui/macro"
import React from "react"
import clsx from "clsx"
import { Icon } from "@silversea-ssc/ui-components-react"
import styles from "./ShipDetails.module.scss"
import { getSuiteFeatureLabels } from "./labels"

const SuiteFeatures: React.FC = () => {
    // const { _ } = useLingui()
    const { thirdGuestCapacity, bathShowerSeparate, connectingSuite, bathShowerCombination, wheelchairAccessible } =
        getSuiteFeatureLabels()
    const suiteFeatureIcon = [
        { name: "3rd-guest-capacity" as const, label: thirdGuestCapacity },
        { name: "connecting-suite" as const, label: connectingSuite },
        { name: "wheelchair" as const, label: wheelchairAccessible },
        { name: "bath-shower-combination" as const, label: bathShowerCombination },
        { name: "bath-shower-separate" as const, label: bathShowerSeparate },
    ]

    return (
        <div className={styles.section}>
            <div className={styles.subTitle}>{t`Suite features`}</div>
            <ul className={clsx(styles.featuresLegend, styles.sectionContent)}>
                {suiteFeatureIcon.map(({ name, label }) => (
                    <li key={name}>
                        <Icon padding={false} className={styles.featureIcon} size="1.5x" name={name} />
                        {label}
                    </li>
                ))}
            </ul>
        </div>
    )
}

export default SuiteFeatures
